/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ equipment: NonNullable<unknown>, from: NonNullable<unknown>, to: NonNullable<unknown> }} Progression_Substituted_EquipmentInputs */

const en_us2_progression_substituted_equipment = /** @type {(inputs: Progression_Substituted_EquipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No ${i?.equipment}? Next time ${i?.from} becomes ${i?.to}`)
};

const pt_br2_progression_substituted_equipment = /** @type {(inputs: Progression_Substituted_EquipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sem ${i?.equipment}? Na próxima, ${i?.from} vira ${i?.to}`)
};

const es_419_progression_substituted_equipment = /** @type {(inputs: Progression_Substituted_EquipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Sin ${i?.equipment}? La próxima vez, ${i?.from} pasa a ser ${i?.to}`)
};

const pt_pt2_progression_substituted_equipment = /** @type {(inputs: Progression_Substituted_EquipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sem ${i?.equipment}? Na próxima, ${i?.from} passa a ${i?.to}`)
};

const fr_fr2_progression_substituted_equipment = /** @type {(inputs: Progression_Substituted_EquipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pas de ${i?.equipment} ? La prochaine fois, ${i?.from} devient ${i?.to}`)
};

const de_de2_progression_substituted_equipment = /** @type {(inputs: Progression_Substituted_EquipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ohne ${i?.equipment}? Nächstes Mal wird ${i?.from} zu ${i?.to}`)
};

const it_it2_progression_substituted_equipment = /** @type {(inputs: Progression_Substituted_EquipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Niente ${i?.equipment}? La prossima volta ${i?.from} diventa ${i?.to}`)
};

/**
* | output |
* | --- |
* | "No {equipment}? Next time {from} becomes {to}" |
*
* @param {Progression_Substituted_EquipmentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progression_substituted_equipment = /** @type {((inputs: Progression_Substituted_EquipmentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progression_Substituted_EquipmentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progression_substituted_equipment(inputs)
	if (locale === "es-419") return es_419_progression_substituted_equipment(inputs)
	if (locale === "pt-PT") return pt_pt2_progression_substituted_equipment(inputs)
	if (locale === "fr-FR") return fr_fr2_progression_substituted_equipment(inputs)
	if (locale === "de-DE") return de_de2_progression_substituted_equipment(inputs)
	if (locale === "it-IT") return it_it2_progression_substituted_equipment(inputs)
	return en_us2_progression_substituted_equipment(inputs)
});
export { progression_substituted_equipment as "progression.substituted_equipment" }